import { render } from "./Tattoo.vue?vue&type=template&id=35f01353&scoped=true"
import script from "./Tattoo.vue?vue&type=script&lang=js"
export * from "./Tattoo.vue?vue&type=script&lang=js"

import "./Tattoo.vue?vue&type=style&index=0&id=35f01353&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f01353"]])

export default __exports__